// import checkSegmentCookie from './checkSegmentCookie';
// import { addToKlaviyoMailingList } from './klaviyoService';

const trackUser = (idParams: any) => {
  if (window) {
    return idParams;
    // const { userId, traits, integrations } = idParams;
    // const addToKlaviyoMailingListCallBack = () => {
    //   const {
    //     Klaviyo: { listId },
    //   } = integrations;
    //   if (listId !== 'do not add') {
    //     return addToKlaviyoMailingList(listId, userId);
    //   }
    //   return;
    // };
    // checkSegmentCookie();
    // if (process.env.ENABLE_SEGMENT) {
    //   // @ts-ignore analytics is a global variable
    //   return analytics.identify(
    //     userId,
    //     traits,
    //     { integrations },
    //     addToKlaviyoMailingListCallBack,
    //   );
    // }
  }
};
export default trackUser;
